var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import fetch from '../../common/fetch';
var defaultConfig = {
    apiPath: '/search/suggest',
    formActionPath: '/search',
};
var SearchClient = /** @class */ (function () {
    function SearchClient(config) {
        this.config = __assign({}, defaultConfig, config);
    }
    SearchClient.prototype.getSuggestions = function (prefix, query) {
        query = encodeURIComponent(query);
        var url = "" + (prefix || '') + this.config.apiPath + "?query=" + query;
        return fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then(function (res) { return res.json(); });
    };
    return SearchClient;
}());
export default SearchClient;
